import type { IconData } from '@stacksjs/iconify-core'

export const text: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M440 168V88H72v80h64v-48h88v280h-56v32h176v-32h-56V120h88v48z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default text
